import { render } from "./LimitedPromotionDaysHeader.vue?vue&type=template&id=0f8c1c04&scoped=true"
import script from "./LimitedPromotionDaysHeader.vue?vue&type=script&lang=js"
export * from "./LimitedPromotionDaysHeader.vue?vue&type=script&lang=js"

import "./LimitedPromotionDaysHeader.vue?vue&type=style&index=0&id=0f8c1c04&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8c1c04"]])

export default __exports__